import React from 'react';
import { Shield, CheckCircle, FileText, Lock } from 'lucide-react';

const KVKK = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <Shield className="h-16 w-16 mx-auto mb-6" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              KVKK Aydınlatma Metni
            </h1>
            <p className="text-xl text-blue-100">
              Kişisel Verilerinizin Korunması ve İşlenmesine İlişkin Aydınlatma Metni
            </p>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Introduction */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
            <div className="flex items-start space-x-4 mb-6">
              <FileText className="h-8 w-8 text-blue-600 flex-shrink-0 mt-1" />
              <div>
                <h2 className="text-2xl font-bold text-gray-800 mb-3">1. Giriş</h2>
                <p className="text-gray-600 leading-relaxed">
                  Pekala olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında veri sorumlusu sıfatıyla, 
                  kişisel verilerinizin güvenliğine ve gizliliğine büyük önem vermekteyiz. Bu aydınlatma metni ile kişisel 
                  verilerinizin hangi amaçlarla işlendiği, aktarıldığı ve korunduğu hakkında sizleri bilgilendirmeyi amaçlıyoruz.
                </p>
              </div>
            </div>
          </div>

          {/* Data Controller */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Veri Sorumlusu</h2>
            <div className="bg-blue-50 rounded-lg p-6 space-y-2 text-gray-700">
              <p><strong>Ünvanı:</strong> Pekala Süt Ürünleri</p>
              <p><strong>Adres:</strong> Koçören 2. OSB Mh. 222. Cd. No:4, Eyyubiye/ŞANLIURFA</p>
              <p><strong>E-posta:</strong> pekala_sut_urunleri@hotmail.com</p>
              <p><strong>Telefon:</strong> 0543 202 63 63</p>
            </div>
          </div>

          {/* Personal Data */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">3. İşlenen Kişisel Veriler</h2>
            <p className="text-gray-600 mb-4">Aşağıdaki kişisel verileriniz işlenebilmektedir:</p>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="flex items-start space-x-3">
                <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-800">Kimlik Bilgileri</h3>
                  <p className="text-sm text-gray-600">Ad, soyad, T.C. kimlik no</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-800">İletişim Bilgileri</h3>
                  <p className="text-sm text-gray-600">Telefon, e-posta, adres</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-800">Müşteri İşlem Bilgileri</h3>
                  <p className="text-sm text-gray-600">Sipariş, ödeme bilgileri</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-semibold text-gray-800">İşlem Güvenliği Bilgileri</h3>
                  <p className="text-sm text-gray-600">IP adresi, çerez kayıtları</p>
                </div>
              </div>
            </div>
          </div>

          {/* Processing Purposes */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Kişisel Verilerin İşlenme Amaçları</h2>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-start space-x-3">
                <span className="text-blue-600 font-bold mt-1">•</span>
                <span>Ürün ve hizmetlerimizin sunulması, siparişlerin işlenmesi</span>
              </li>
              <li className="flex items-start space-x-3">
                <span className="text-blue-600 font-bold mt-1">•</span>
                <span>Müşteri ilişkileri yönetimi ve müşteri memnuniyetinin sağlanması</span>
              </li>
              <li className="flex items-start space-x-3">
                <span className="text-blue-600 font-bold mt-1">•</span>
                <span>Yasal yükümlülüklerin yerine getirilmesi</span>
              </li>
              <li className="flex items-start space-x-3">
                <span className="text-blue-600 font-bold mt-1">•</span>
                <span>İletişim faaliyetlerinin yürütülmesi</span>
              </li>
              <li className="flex items-start space-x-3">
                <span className="text-blue-600 font-bold mt-1">•</span>
                <span>Pazarlama ve reklam faaliyetlerinin yürütülmesi</span>
              </li>
              <li className="flex items-start space-x-3">
                <span className="text-blue-600 font-bold mt-1">•</span>
                <span>İç denetim ve soruşturma faaliyetlerinin yürütülmesi</span>
              </li>
            </ul>
          </div>

          {/* Legal Basis */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Kişisel Verilerin İşlenme Hukuki Sebepleri</h2>
            <p className="text-gray-600 mb-3">Kişisel verileriniz aşağıdaki hukuki sebeplere dayanılarak işlenmektedir:</p>
            <div className="space-y-2 text-gray-600">
              <p>• Açık rızanızın bulunması</p>
              <p>• Sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması</p>
              <p>• Yasal yükümlülüğün yerine getirilmesi</p>
              <p>• Meşru menfaatlerimizin bulunması</p>
            </div>
          </div>

          {/* Data Sharing */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">6. Kişisel Verilerin Aktarılması</h2>
            <p className="text-gray-600 mb-4">
              Kişisel verileriniz, yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda ve KVKK'da öngörülen 
              temel ilkelere uygun olarak;
            </p>
            <ul className="space-y-2 text-gray-600">
              <li>• İş ortaklarımıza</li>
              <li>• Tedarikçilerimize</li>
              <li>• Hizmet sağlayıcılarımıza</li>
              <li>• Yasal mercilere</li>
              <li>• Yurt içi ve yurt dışı iş ortaklarımıza aktarılabilmektedir.</li>
            </ul>
          </div>

          {/* Data Subject Rights */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
            <div className="flex items-start space-x-4">
              <Lock className="h-8 w-8 text-blue-600 flex-shrink-0 mt-1" />
              <div>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">7. Kişisel Veri Sahibinin Hakları</h2>
                <p className="text-gray-600 mb-4">KVKK'nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:</p>
                <div className="bg-blue-50 rounded-lg p-6 space-y-3 text-gray-700">
                  <p>✓ Kişisel verilerinizin işlenip işlenmediğini öğrenme</p>
                  <p>✓ İşlenmişse buna ilişkin bilgi talep etme</p>
                  <p>✓ İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</p>
                  <p>✓ Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</p>
                  <p>✓ Eksik veya yanlış işlenmişse düzeltilmesini isteme</p>
                  <p>✓ KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde silinmesini veya yok edilmesini isteme</p>
                  <p>✓ Aktarıldığı üçüncü kişilere yukarıdaki işlemlerin bildirilmesini isteme</p>
                  <p>✓ Münhasıran otomatik sistemler ile analiz edilmesi nedeniyle aleyhinize bir sonuç doğması durumunda itiraz etme</p>
                  <p>✓ Kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme</p>
                </div>
              </div>
            </div>
          </div>

          {/* Application Method */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white rounded-xl shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold mb-4">8. Başvuru Yöntemi</h2>
            <p className="mb-4 text-blue-100">
              Yukarıda belirtilen haklarınızı kullanmak için aşağıdaki yöntemlerle başvurabilirsiniz:
            </p>
            <div className="space-y-3">
              <div className="bg-white/10 rounded-lg p-4">
                <p className="font-semibold mb-1">Yazılı Başvuru:</p>
                <p className="text-sm text-blue-100">Koçören 2. OSB Mh. 222. Cd. No:4, Eyyubiye/ŞANLIURFA adresine kimliğinizi tespit edici belgeler ile başvuru</p>
              </div>
              <div className="bg-white/10 rounded-lg p-4">
                <p className="font-semibold mb-1">E-posta:</p>
                <p className="text-sm text-blue-100">pekala_sut_urunleri@hotmail.com adresine güvenli elektronik imza ile imzalanmış başvuru</p>
              </div>
            </div>
            <p className="mt-4 text-sm text-blue-100">
              Başvurularınız, talebin niteliğine göre en geç 30 gün içinde ücretsiz olarak sonuçlandırılacaktır.
            </p>
          </div>

          {/* Update Date */}
          <div className="text-center text-gray-500 text-sm">
            <p>Son Güncelleme: {new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KVKK;
